'use strict';
const freezeConfig = require('./freeze-config'),
	ciscoAddIns = require('./add-ins/cisco'),
	stripePlans = {
		durationToPeriod: {
			month: 'monthly',
			year: 'annual'
		},
		periodInMonths: {
			month: 1,
			year: 12
		},
		accountTypePostfix: {
			'mindmup-gold': '',
			'mindmup-gold-team': ' team',
			'mindmup-gold-domain': ' domain'
		},
		currencies: {
			USD: {
				prefix: '$',
				postfix: ' USD',
				sources: ['card', 'amazon-pay']
			},
			EUR: {
				prefix: '€',
				postfix: ' EUR',
				sources: ['card', 'amazon-pay']
			},
			GBP: {
				prefix: '£',
				postfix: ' GBP',
				sources: ['card', 'amazon-pay']
			}
		},
		upgradePlanTypeActions: {
			'personalYearly': 'ChangeToYearly',
			'smallTeam': 'ChangeToSmallTeam',
			'mediumTeam': 'ChangeToMediumTeam',
			'largeTeam': 'ChangeToLargeTeam'
		},

		planId: {
			personalMonthlyUSD: '1_GB_for_1_month',
			personalYearlyUSD: '1_GB_for_12_months_33213873860960',
			smallTeamUSD: 'small_team_12_months',
			mediumTeamUSD: 'medium_team_12_months',
			largeTeamUSD: 'large_team_12_months',
			domainUSD: 'domain_for_12_months',
			personalMonthlyEUR: 'personal_1_month_EUR',
			personalYearlyEUR: 'personal_12_months_EUR',
			smallTeamEUR: 'small_team_12_months_EUR',
			mediumTeamEUR: 'medium_team_12_months_EUR',
			largeTeamEUR: 'large_team_12_months_EUR',
			domainEUR: 'domain_12_months_EUR',
			personalMonthlyGBP: 'personal_1_month_GBP',
			personalYearlyGBP: 'personal_12_months_GBP',
			smallTeamGBP: 'small_team_12_months_GBP',
			mediumTeamGBP: 'medium_team_12_months_GBP',
			largeTeamGBP: 'large_team_12_months_GBP',
			domainGBP: 'domain_12_months_GBP'
		},
		planMetadata: {
			'1_GB_for_1_month': {
				account_type: 'mindmup-gold',
				max_linked_emails: 1,
				upgradable_to: ['1_GB_for_12_months_33213873860960', 'small_team_12_months'],
				addIns: ['crowdlink_personal_1_month_USD', 'cisco_personal_1_month_USD'],
				price: '2.99',
				currency: 'USD',
				period: 'month',
				type: 'personal',
				purchaseAction: 'BuySubscription'
			},
			'1_GB_for_12_months_33213873860960': {
				account_type: 'mindmup-gold',
				max_linked_emails: 1,
				upgradable_to: ['small_team_12_months'],
				addIns: ['crowdlink_personal_12_months_USD', 'cisco_personal_12_months_USD'],
				requireUpgradeAction: 'ChangeToYearlyUSD',
				price: '25',
				currency: 'USD',
				period: 'year',
				type: 'personal',
				purchaseAction: 'BuySubscription'
			},
			'small_team_12_months': {
				account_type: 'mindmup-gold-team',
				max_linked_emails: 9,
				upgradable_to: ['medium_team_12_months'],
				addIns: ['crowdlink_team10_12_months_USD', 'cisco_team10_12_months_USD'],
				requireUpgradeAction: 'ChangeToSmallTeamUSD',
				price: '50',
				currency: 'USD',
				period: 'year',
				type: 'team',
				typeLabel: '10 user team',
				purchaseAction: 'BuySmallTeamSubscription'
			},
			'medium_team_12_months': {
				account_type: 'mindmup-gold-team',
				max_linked_emails: 99,
				upgradable_to: ['large_team_12_months'],
				addIns: ['crowdlink_team100_12_months_USD', 'cisco_team100_12_months_USD'],
				requireUpgradeAction: 'ChangeToMediumTeamUSD',
				price: '100',
				currency: 'USD',
				period: 'year',
				type: 'team',
				typeLabel: '100 user team',
				purchaseAction: 'BuyTeamSubscription'
			},
			'large_team_12_months': {
				account_type: 'mindmup-gold-team',
				max_linked_emails: 199,
				requireUpgradeAction: 'ChangeToLargeTeamUSD',
				addIns: ['crowdlink_team200_12_months_USD', 'cisco_team200_12_months_USD'],
				price: '150',
				currency: 'USD',
				period: 'year',
				type: 'team',
				typeLabel: '200 user team',
				purchaseAction: 'BuyTeamSubscription'
			},
			'domain_for_12_months': {
				account_type: 'mindmup-gold-domain',
				max_linked_emails: 1,
				addIns: ['crowdlink_domain_12_months_USD', 'cisco_domain_12_months_USD', 'ms-teams_domain_12_months_USD'],
				price: '100',
				currency: 'USD',
				period: 'year',
				type: 'domain',
				purchaseAction: 'BuyDomainSubscription',
				trialPeriodDays: 7
			},
			'personal_1_month_EUR': {
				account_type: 'mindmup-gold',
				max_linked_emails: 1,
				upgradable_to: ['personal_12_months_EUR', 'small_team_12_months_EUR'],
				addIns: ['crowdlink_personal_1_month_EUR', 'cisco_personal_1_month_EUR'],
				price: '2.99',
				currency: 'EUR',
				period: 'month',
				type: 'personal',
				purchaseAction: 'BuySubscription'
			},
			'personal_12_months_EUR': {
				account_type: 'mindmup-gold',
				max_linked_emails: 1,
				upgradable_to: ['small_team_12_months_EUR'],
				addIns: ['crowdlink_personal_12_months_EUR', 'cisco_personal_12_months_EUR'],
				requireUpgradeAction: 'ChangeToYearlyEUR',
				price: '25',
				currency: 'EUR',
				period: 'year',
				type: 'personal',
				purchaseAction: 'BuySubscription'
			},
			'small_team_12_months_EUR': {
				account_type: 'mindmup-gold-team',
				max_linked_emails: 9,
				upgradable_to: ['medium_team_12_months_EUR'],
				addIns: ['crowdlink_team10_12_months_EUR', 'cisco_team10_12_months_EUR'],
				requireUpgradeAction: 'ChangeToSmallTeamEUR',
				price: '50',
				currency: 'EUR',
				period: 'year',
				type: 'team',
				typeLabel: '10 user team',
				purchaseAction: 'BuySmallTeamSubscription'
			},
			'medium_team_12_months_EUR': {
				account_type: 'mindmup-gold-team',
				max_linked_emails: 99,
				upgradable_to: ['large_team_12_months_EUR'],
				addIns: ['crowdlink_team100_12_months_EUR', 'cisco_team100_12_months_EUR'],
				requireUpgradeAction: 'ChangeToMediumTeamEUR',
				price: '100',
				currency: 'EUR',
				period: 'year',
				type: 'team',
				typeLabel: '100 user team',
				purchaseAction: 'BuyTeamSubscription'
			},
			'large_team_12_months_EUR': {
				account_type: 'mindmup-gold-team',
				max_linked_emails: 199,
				addIns: ['crowdlink_team200_12_months_EUR', 'cisco_team200_12_months_EUR'],
				requireUpgradeAction: 'ChangeToLargeTeamEUR',
				price: '150',
				currency: 'EUR',
				period: 'year',
				type: 'team',
				typeLabel: '200 user team',
				purchaseAction: 'BuyTeamSubscription'
			},
			'domain_12_months_EUR': {
				account_type: 'mindmup-gold-domain',
				max_linked_emails: 1,
				addIns: ['crowdlink_domain_12_months_EUR', 'cisco_domain_12_months_EUR', 'ms-teams_domain_12_months_EUR'],
				price: '100',
				currency: 'EUR',
				period: 'year',
				type: 'domain',
				purchaseAction: 'BuyDomainSubscription',
				trialPeriodDays: 7
			},
			'personal_1_month_GBP': {
				account_type: 'mindmup-gold',
				max_linked_emails: 1,
				upgradable_to: ['personal_12_months_GBP', 'small_team_12_months_GBP'],
				addIns: ['crowdlink_personal_1_month_GBP', 'cisco_personal_1_month_GBP'],
				price: '2.99',
				currency: 'GBP',
				period: 'month',
				type: 'personal',
				purchaseAction: 'BuySubscription'
			},
			'personal_12_months_GBP': {
				account_type: 'mindmup-gold',
				max_linked_emails: 1,
				upgradable_to: ['small_team_12_months_GBP'],
				requireUpgradeAction: 'ChangeToYearlyGBP',
				addIns: ['crowdlink_personal_12_months_GBP', 'cisco_personal_12_months_GBP'],
				price: '25',
				currency: 'GBP',
				period: 'year',
				type: 'personal',
				purchaseAction: 'BuySubscription'
			},
			'small_team_12_months_GBP': {
				account_type: 'mindmup-gold-team',
				max_linked_emails: 9,
				upgradable_to: ['medium_team_12_months_GBP'],
				addIns: ['crowdlink_team10_12_months_GBP', 'cisco_team10_12_months_GBP'],
				requireUpgradeAction: 'ChangeToSmallTeamGBP',
				price: '50',
				currency: 'GBP',
				period: 'year',
				type: 'team',
				typeLabel: '10 user team',
				purchaseAction: 'BuySmallTeamSubscription'
			},
			'medium_team_12_months_GBP': {
				account_type: 'mindmup-gold-team',
				max_linked_emails: 99,
				upgradable_to: ['large_team_12_months_GBP'],
				addIns: ['crowdlink_team100_12_months_GBP', 'cisco_team100_12_months_GBP'],
				requireUpgradeAction: 'ChangeToMediumTeamGBP',
				price: '100',
				currency: 'GBP',
				period: 'year',
				type: 'team',
				typeLabel: '100 user team',
				purchaseAction: 'BuyTeamSubscription'
			},
			'large_team_12_months_GBP': {
				account_type: 'mindmup-gold-team',
				max_linked_emails: 199,
				addIns: ['crowdlink_team200_12_months_GBP', 'cisco_team200_12_months_GBP'],
				requireUpgradeAction: 'ChangeToLargeTeamGBP',
				price: '150',
				currency: 'GBP',
				period: 'year',
				type: 'team',
				typeLabel: '200 user team',
				purchaseAction: 'BuyTeamSubscription'
			},
			'domain_12_months_GBP': {
				account_type: 'mindmup-gold-domain',
				max_linked_emails: 1,
				addIns: ['crowdlink_domain_12_months_GBP', 'cisco_domain_12_months_GBP', 'ms-teams_domain_12_months_GBP'],
				price: '100',
				currency: 'GBP',
				period: 'year',
				type: 'domain',
				purchaseAction: 'BuyDomainSubscription',
				trialPeriodDays: 7
			}
		}
	},
	calcPriceWithCisco = (planMetadata, quantity) => {
		const basicPrice = parseFloat(planMetadata.price),
			ciscoAddInName = planMetadata.addIns.find(a => /cisco/.test(a)),
			addInType = ciscoAddInName.split('_')[1],
			addInPrice = ciscoAddIns.prices[planMetadata.period][addInType].find(c => c.quantity === quantity),
			fullPrice = basicPrice + (addInPrice.price_in_units/addInPrice.quantity);
		return fullPrice.toFixed(2);
	},
	productWithAddIn = (primary, addIn, addInQuantity) => {
		const result = {};
		result[primary] = 1;
		result[addIn] = addInQuantity;
		return result;
	};
Object.keys(stripePlans.planId).forEach(planId => {
	const stripePlanId = stripePlans.planId[planId],
		planMetadata = stripePlans.planMetadata[stripePlanId],
		ciscoAddIn = planMetadata.addIns.find (a => /cisco/.test(a));
	if (ciscoAddIn) {
		const quantity = 100,
			products = productWithAddIn(stripePlanId, ciscoAddIn, quantity),
			ciscoPlanMetadata = Object.assign({}, planMetadata, {
				products,
				price: calcPriceWithCisco(planMetadata, quantity),
				type: `cisco-${planMetadata.type}`,
				trialPeriodDays: 7,
				typeLabel: (planMetadata.typeLabel || planMetadata.type) + ' + 100 collaborators'
			});
		stripePlans.planMetadata[`cisco-${stripePlanId}`] = ciscoPlanMetadata;
		stripePlans.planId[`cisco-${planId}`] = `cisco-${stripePlanId}`;
	}
});

stripePlans.accountTypes = Object.keys(stripePlans.accountTypePostfix);
module.exports = freezeConfig(stripePlans);
